import {
  Box,
  Button,
  Icon,
  PlacementWithLogical,
  Text,
} from "@chakra-ui/react";
import { User } from "firebase/auth";
import { FaWallet } from "react-icons/fa";
import { SUPPORTED_CHAINS } from "~/core/constants";
import { EvmChains, ProjectDocument } from "~/core/types";
import NftRequirement from "./NftRequirement";
import TokenBalanceRequirement from "./TokenBalanceRequirement";
import WalletBalanceRequirement from "./WalletBalanceRequirement";

export default function ConnectWalletRequirement({
  project,
  userWallet,
  solanaLogin,
  solanaLoading,
  flowLogin,
  flowLoading,
  evmLogin,
  evmLoading,
  user,
  tooltipPosition,
  registerationErrorMessage,
  isWalletBalanceTooltipOpen,
  isNftTooltipOpen,
}: {
  project: ProjectDocument;
  userWallet?: string;
  solanaLogin: (mode?: "login" | "add") => void;
  solanaLoading: boolean;
  flowLogin: (mode?: "login" | "add") => void;
  flowLoading: boolean;
  evmLogin: (mode: "login" | "add", chain: EvmChains) => void;
  evmLoading: boolean;
  user?: User;
  tooltipPosition?: PlacementWithLogical;
  registerationErrorMessage: string;
  isWalletBalanceTooltipOpen: boolean;
  isNftTooltipOpen: boolean;
}) {
  // project.wallet.required is undefined for older projects
  if (project?.wallet?.required === false) return null;

  return (
    <>
      <Box
        mt={0}
        px={8}
        py={4}
        w={"100%"}
        borderTop={project?.signupAccess?.isEndDateRequired ? "1px" : 0}
        borderBottom={"1px"}
        borderColor={"boxBorder"}
        color={"descText"}
      >
        <Box
          w="100%"
          display="flex"
          flexDirection="row"
          alignItems="center"
          mb={4}
        >
          <Icon as={FaWallet} fontSize="18" mr={2} />

          <Text fontSize="18" fontWeight="500">
            {`${SUPPORTED_CHAINS[project?.chain]?.name} Wallet`}
          </Text>

          {userWallet && (
            <Text ml={"auto"} mr={1} mt={"0.5"} fontWeight={500}>
              {userWallet.slice(0, 6)}...
              {userWallet.slice(userWallet.length - 4, userWallet.length)}
            </Text>
          )}

          {!userWallet && (
            <Button
              fontSize={"14"}
              colorScheme={"discord"}
              rounded="full"
              color={"gray.200"}
              fontWeight={400}
              ml={"auto"}
              isLoading={solanaLoading || flowLoading || evmLoading}
              onClick={() => {
                const mode = user ? "add" : "login";
                if (project?.chain === "solana") {
                  solanaLogin(mode);
                } else if (project?.chain === "flow") {
                  flowLogin(mode);
                } else {
                  evmLogin(mode, project?.chain);
                }
              }}
            >
              Connect
            </Button>
          )}
        </Box>

        {/* WALLET BALANCE */}
        <WalletBalanceRequirement
          project={project}
          isTooltipOpen={isWalletBalanceTooltipOpen}
          tooltipPosition={tooltipPosition}
          tooltipLabel={registerationErrorMessage}
        />
        {/* TOKEN BALANCE */}
        <TokenBalanceRequirement project={project} />
        {/* NFT */}
        <NftRequirement
          project={project}
          isTooltipOpen={isNftTooltipOpen}
          tooltipPosition={tooltipPosition}
        />
      </Box>
    </>
  );
}
